import { FC, forwardRef } from "react";
import styled from "styled-components";
import { CreateTransient } from "../../shared/types";
import { Button, RegularButtonProps } from "../button";

export type FilterProps = FilterOnlyProps & Omit<RegularButtonProps, "variant">;

type FilterOnlyProps = {
  isOn?: boolean;
};

export const Filter: FC<FilterProps> = forwardRef<
  HTMLButtonElement,
  FilterProps
>(({ isOn = false, children, ...rest }, ref) => {
  return (
    <FilterButton $isOn={isOn} variant="secondary" {...rest} ref={ref}>
      {children}
    </FilterButton>
  );
});

const FilterButton = styled(Button)<CreateTransient<FilterOnlyProps>>`
  background-color: ${({ $isOn, theme }) =>
    $isOn ? theme.COLORS.BLACK_GREY : theme.COLORS.WHITE};
  color: ${({ $isOn, theme }) =>
    $isOn ? theme.COLORS.WHITE : theme.COLORS.BLACK_GREY};
  padding: ${({ theme }) => `${theme.SPACING.SM} ${theme.SPACING.MD}`};
  font-size: ${({ theme }) => theme.FONT.SIZE.BODY};
  font-weight: ${({ theme }) => theme.FONT.WEIGHT.MEDIUM};
  font-family: ${({ theme }) => theme.FONT.FAMILY.HEADERS};

  &:hover {
    background-color: ${({ $isOn, theme }) =>
      $isOn ? theme.COLORS.BLACK_GREY : theme.COLORS.WHITE};
    text-decoration: underline;
  }
`;
